import { Box, Tab, Tabs } from '../ui';
import { BookmarkIcon, SettingsIcon } from '../icons';

/**
 * Tab keys retained for back-compat with the page-level
 * `selectedTab` state in CourseDetail. Overview and Curriculum
 * (lessons) used to surface in this strip; they're no longer shown
 * here — Overview is the page's default render, and Curriculum is
 * reached via the in-page Course Overview CTA which flips
 * `selectedTab` to 'lessons' directly.
 */
export type CourseDetailTabKey = 'overview' | 'lessons' | 'assignment-setup' | 'assignments';

interface TabNavigationProps {
  selectedTab: CourseDetailTabKey;
  onTabChange: (tab: CourseDetailTabKey) => void;
  isExternal?: boolean;
  // Show Assignment Setup / Assignments tabs (managers only).
  showManagerTabs?: boolean;
}

export default function TabNavigation({ selectedTab, onTabChange, showManagerTabs }: TabNavigationProps) {
  // Nothing to render unless the manager tabs are active — the page
  // hides this component entirely for plain learners.
  if (!showManagerTabs) return null;
  return (
    <Box sx={{ width: '95%', maxWidth: '1500px', borderBottom: 1, borderColor: 'divider' }}>
      <Tabs value={selectedTab} onChange={(_e, value) => onTabChange(value)} aria-label="course management sections">
        <Tab label="Assignment Setup" value="assignment-setup" icon={<SettingsIcon />} iconPosition="start" />
        <Tab label="Assignments" value="assignments" icon={<BookmarkIcon />} iconPosition="start" />
      </Tabs>
    </Box>
  );
}
